/* Built In Imports */
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';

/* External Imports */
import { ChevronDownIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  CloseButton,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Image,
  Link,
  List,
  ListItem,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import { GoGlobe } from 'react-icons/go';
import { HiOutlineBars2 } from 'react-icons/hi2';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import { isOpenInNewTab, refineUrlDomain } from '@moms/Utility/utils';

/* Styles */
import HeaderSt from '@moms/styleData/HeaderSt';
/* Services */

/**
 *
 * @param {Object} headerMenuData
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const Header = ({
  headerMenuData,
  availableLocales,
  region,
  lang,
  currentUserRegion,
  setCurrentUserRegion,
  page,
  firstLevel,
}) => {
  const [isVisible, setIsVisible] = useState(firstLevel);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  // console.log(
  //   headerMenuData,
  //   availableLocales,
  //   region,
  //   lang,
  //   currentUserRegion,
  //   setCurrentUserRegion,
  //   page,
  //   'Header'
  // );
  // console.log(region, lang, 'region, lang');
  const router = useRouter();
  const ipl = router.asPath.includes('miracle-of-mind/ipl');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();
  const allIsoMainMenus = headerMenuData.allIsoMainMenus;
  const logo = allIsoMainMenus.find(el => el.key === 'logo');
  const langSwitch = allIsoMainMenus.find(el => el.key === 'lang-switcher');
  const menuTitle = langSwitch?.submenuItems.find(
    el => el?.url.indexOf(`${region}/${lang}`) > -1
  );
  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);
  const listenToScroll = () => {
    const heightToHideFrom = window.innerHeight * 1;

    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    // console.log('winScroll', winScroll, heightToHideFrom);

    if (winScroll > heightToHideFrom && !firstLevel) {
      // console.log('winScroll', winScroll, registerDiv, inViewPort);
      // setIsVisible(true);
      if (
        document.documentElement.scrollTop >
        document.body.scrollHeight - window.innerHeight * 1
      ) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    } else if (firstLevel) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  useEffect(() => {
    onClose();
  }, [lang, region, firstLevel]);
  return (
    <Box
      w="100%"
      bg={{
        base: '#010102',
        md: isVisible ? '#010102' : 'rgba(15, 15, 15, 0.10)',
      }}
      py={2}
      px={4}
      as="header"
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        as="nav"
        flexWrap="wrap"
        maxW={1200}
        mx="auto"
        w="100%"
      >
        <Box
          className="Logo"
          w={{ base: '44px', md: '72px' }}
          h={{ base: '44px', md: '72px' }}
        >
          {/* <NextLink
              // target={isOpenInNewTab(allIsoMainMenus[1].url) ? '_blank' : ''}
              passHref
            > */}
          {isVisible && (
            <Link
              _hover={{ textDecor: 'none' }}
              href={refineUrlDomain('/', region, lang)}
            >
              <Image
                src={logo?.icon.url}
                alt=""
                w={{ base: '44px', md: '72px' }}
                h={{ base: '44px', md: '72px' }}
              />
            </Link>
          )}
          {/* </NextLink> */}
        </Box>
        <Flex gap="1rem" alignItems="center">
          <List
            listStyleType="none"
            display={{ base: 'none', md: 'flex' }}
            alignItems="center"
            gridGap="2rem"
          >
            {allIsoMainMenus.map((menu, index) => {
              if (menu.key === 'logo' || menu.key === 'lang-switcher') {
                return;
              }
              return (
                <ListItem key={index}>
                  {/* <NextLink
                    passHref
                  > */}
                  <Link
                    _hover={{ textDecor: 'none' }}
                    href={refineUrlDomain(menu?.url, region, lang)}
                    target={isOpenInNewTab(menu?.url) ? '_blank' : ''}
                  >
                    <Text
                      fontFamily="Geist"
                      py="6px"
                      color="#fff"
                      transition="all 0.2s ease-out"
                      borderBottom={
                        menu.url === firstLevel
                          ? '2px solid #EC1B2E'
                          : '2px solid transparent'
                      }
                      _hover={{ borderBottom: '2px solid #EC1B2E' }}
                      fontWeight={500}
                      {...HeaderSt[lang].link}
                    >
                      {menu.title}
                    </Text>
                  </Link>
                  {/* </NextLink> */}
                </ListItem>
              );
            })}
          </List>
          <Flex alignItems="center" gap="1rem" ml=".5rem">
            {!ipl && (
              <Menu
                fontFamily="Geist"
                color="#fff"
                fontWeight={500}
                fontSize="14px"
              >
                <MenuButton
                  rounded="full"
                  as={Button}
                  fontFamily="Geist"
                  px={2}
                  py={1}
                  border="1px solid rgba(255, 255, 255, 0.20)"
                  background="transparent"
                  variant="outline"
                  _hover={{ bg: 'transparent' }}
                  _focus={{ bg: 'transparent' }}
                  _active={{ bg: 'transparent' }}
                  color="#fff"
                  fontWeight={400}
                  leftIcon={<GoGlobe />}
                  rightIcon={<ChevronDownIcon />}
                  {...HeaderSt[lang].link}
                >
                  {menuTitle?.title?.slice(0, 3)}
                </MenuButton>
                <MenuList minW={1} w="auto" py="0" bg="#000" border="none">
                  {langSwitch?.submenuItems.map(menu => {
                    return (
                      <MenuItem
                        py=".5rem"
                        px="1rem"
                        bg="#000"
                        as={Link}
                        key={nanoid()}
                        color="#fff"
                        // href="#"
                        _hover={{
                          color: '#fff',
                          textDecor: 'none',
                          bg: '#000',
                        }}
                        href={`/${menu.url}/miracle-of-mind/${
                          firstLevel ? firstLevel : ''
                        }`}
                        {...HeaderSt[lang].link}
                      >
                        {menu?.title}
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </Menu>
            )}
            <Box
              display={{ base: 'inline-block', md: 'none' }}
              color="#fff"
              ref={btnRef}
            >
              <HiOutlineBars2 size={24} colorScheme="teal" onClick={onOpen} />
            </Box>
          </Flex>
        </Flex>
      </Flex>
      <Drawer
        isOpen={isMobile && isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        size="full"
        display={{ base: 'block', md: 'none' }}
      >
        <DrawerOverlay bg="#010102" />
        <DrawerContent px="0">
          <DrawerHeader w="100%">
            <Flex w="100%" justifyContent="space-between">
              <Box className="Logo">
                {/* <NextLink
                  passHref
                > */}
                <Link
                  _hover={{ textDecor: 'none' }}
                  href={refineUrlDomain('/', region, lang)}
                  target={
                    isOpenInNewTab(allIsoMainMenus[1]?.url) ? '_blank' : ''
                  }
                >
                  <Image
                    src={logo?.icon.url}
                    alt=""
                    w={{ base: '44px', md: '72px' }}
                    h={{ base: '44px', md: '72px' }}
                  />
                </Link>
                {/* </NextLink> */}
              </Box>
              <Flex alignItems="center" gap="1rem" ml=".5rem">
                {!ipl && (
                <Menu
                  fontFamily="Geist"
                  color="#fff"
                  fontWeight={500}
                  fontSize="14px"
                  ml=".5rem"
                >
                  <MenuButton
                    rounded="full"
                    as={Button}
                    fontFamily="Geist"
                    px={2}
                    py={1}
                    color="#fff"
                    border="1px solid rgba(255, 255, 255, 0.20)"
                    background="transparent"
                    variant="outline"
                    _hover={{ bg: 'transparent' }}
                    _focus={{ bg: 'transparent' }}
                    _active={{ bg: 'transparent' }}
                    fontWeight={400}
                    leftIcon={<GoGlobe />}
                    rightIcon={<ChevronDownIcon />}
                    {...HeaderSt[lang].link}
                  >
                    {menuTitle?.title?.slice(0, 3)}
                  </MenuButton>
                  <MenuList minW={1} w="auto" py="0" bg="#000" border="none">
                    {langSwitch?.submenuItems.map(menu => {
                      return (
                        <MenuItem
                          py=".5rem"
                          px="1rem"
                          bg="#000"
                          as={Link}
                          color="#fff"
                          // href="#"
                          _hover={{
                            color: '#fff',
                            textDecor: 'none',
                            bg: '#000',
                          }}
                          key={nanoid()}
                          href={`/${menu.url}/miracle-of-mind/${
                            firstLevel ? firstLevel : ''
                          }`}
                          {...HeaderSt[lang].link}
                        >
                          {menu.title}
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </Menu>
                )}
                <Box>
                  <CloseButton
                    size="1.5rem"
                    onClick={onClose}
                    color="#FFFFFF"
                  />
                </Box>
              </Flex>
            </Flex>
          </DrawerHeader>

          <DrawerBody borderTop="1px solid rgba(255, 255, 255, 0.20)">
            <Box>
              <Box>
                <List
                  mt="1.5rem"
                  listStyleType="none"
                  alignItems="center"
                  gridGap="1rem"
                  display="flex"
                  w="100%"
                  flexDir="column"
                  justifyContent="center"
                >
                  {allIsoMainMenus.map((menu, index) => {
                    if (menu.key === 'logo' || menu.key === 'lang-switcher') {
                      return;
                    }
                    return (
                      <ListItem py={2} key={nanoid()}>
                        {/* <NextLink
                          passHref
                        > */}
                        <Link
                          _hover={{ textDecor: 'none' }}
                          href={refineUrlDomain(menu?.url, region, lang)}
                          target={isOpenInNewTab(menu?.url) ? '_blank' : ''}
                        >
                          <Text
                            fontFamily="Geist"
                            color="#fff"
                            fontWeight={500}
                            {...HeaderSt[lang].link}
                          >
                            {menu.title}
                          </Text>
                        </Link>
                        {/* </NextLink> */}
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};
export default Header;
